import { useTranslation } from 'react-i18next';

export default function MenuNote() {
  const { t } = useTranslation();

  return (
    <div className="max-w-7xl mx-auto px-4 md:px-6 mb-12">
      <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 bg-[#F57F25]/5 border border-[#F57F25]/15 rounded-xl px-6 py-4">
        <div className="w-8 h-8 flex items-center justify-center shrink-0">
          <i className="ri-information-line text-[#F57F25] text-xl"></i>
        </div>
        <p className="text-white/60 text-sm leading-relaxed">
          <span className="text-[#F57F25] font-semibold">{t('menu_note_bold')}</span>{' '}
          {t('menu_note')}
        </p>
      </div>
    </div>
  );
}
